<style lang="scss"></style>

<template>
  <div ref="container" class="container" style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;position: sticky;top: 0;background: #202027;padding: 20px;padding-bottom: 14px;">
      <div style="display: flex;align-items: center;">
        <!-- <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t("xiangjiaojishengchanhexinzhibiao") }}
        </p> -->
      </div>

      <div style="font-size: 16px;line-height: 22px;color: #F4F4F4;text-align: center;">OEE:{{ ((xiangjiaoSumKaijilv * xiangjiaoSumJiadonglv * (xiangjiaoGoodSum / xiangjiaoSum)) / 100).toFixed(1) }}%</div>

    </div>
    <div style="padding: 0px  10px 20px 10px;display: flex;justify-content: space-around;" :style="{ height: contentHeight + 'px' }">
      <div style="width: 30%;display: flex;flex-direction: column;align-items: center;justify-content: space-between;">
        <div style="flex: 1;">
          <img :src="require('@@/assets/img/web/cockpit/yibiaopan_lan/yibiaopan_lan_' + parseInt((xiangjiaoSumKaijilv * 41) / 100) + '.png')" :style="{ width: 'auto', height: (contentHeight - 94) + 'px' }" />
          <div style="margin-top: -44%;text-align: center;;">
            <div style="color:white;font-weight:700px;font-size:28px">{{ xiangjiaoSumKaijilv }}%</div>
            <div style="color:white;font-weight:700px;font-size:16px">{{ $t("xiangjiaojikaijilv") }}</div>
          </div>
        </div>
        <div style="margin-top: 0px;">
          <p style="font-size:16px;color:#C0C4CC;text-align: center;">
            <span>{{ $t("tongjishebei") }}</span>
            <span style="color:white;margin-left: 8px;">{{ cockpitData.reportByYear.equipmentCount }} {{ $t("shebei-tai") }}</span>
          </p>
          <p style="font-size:16px;color:#C0C4CC;text-align: center;margin-top: 8px;">
            <span>{{ $t("leijikaijishijian") }}</span>
            <span style="color:white;margin-left: 8px;">{{ xiangjiaoSumKaijishijian }} {{ $t("xiaoshi") }}</span>
          </p>
        </div>
      </div>
      <div style="width:30%;display: flex;flex-direction: column;align-items: center;justify-content: space-between;">
        <div style="flex: 1;">
          <img :src="require('@@/assets/img/web/cockpit/yibiaopan_lv/yibiaopan_lv_' + parseInt((xiangjiaoSumJiadonglv * 41) / 100) + '.png')" :style="{ width: 'auto', height: (contentHeight - 94) + 'px' }" />
          <div style="margin-top: -44%;text-align: center;">
            <div style="color:white;font-weight:700px;font-size:28px">{{ xiangjiaoSumJiadonglv.toFixed(2) }}%</div>
            <div style="color:white;font-weight:700px;font-size:16px">{{ $t("xiangjiaojiperfomance") }}</div>
          </div>
        </div>

        <div style="margin-top: 0px;">
          <p style="font-size:16px;color:#C0C4CC;text-align: center;">
            <span>{{ $t("leijikaijishijian") }}</span>
            <span style="color:white;margin-left: 8px;">{{ xiangjiaoSumKaijishijian }} {{ $t("xiaoshi") }}</span>
          </p>
          <p style="font-size:16px;color:#C0C4CC;text-align: center;margin-top: 8px;">
            <span>{{ $t("leijiyunxingshijian") }}</span>
            <span style="color:white;margin-left: 8px;">{{ xiangjiaoSumRunTime.toFixed(1) }} {{ $t("xiaoshi") }}</span>
          </p>
        </div>
      </div>
      <div style="width:30%;display: flex;flex-direction: column;align-items: center;justify-content: space-between">
        <div>
          <img :src="require('@@/assets/img/web/cockpit/yibiaopan_zi/yibiaopan_zi_' + parseInt((xiangjiaoGoodSum / xiangjiaoSum * 100 * 41) / 100) + '.png')" :style="{ width: 'auto', height: (contentHeight - 94) + 'px' }" />
          <div style="margin-top: -44%;text-align: center;">
            <div style="color:white;font-weight:700px;font-size:28px">{{ ((xiangjiaoGoodSum / xiangjiaoSum * 100).toFixed(1)) == '100.0' ? '99.9' : (xiangjiaoGoodSum / xiangjiaoSum * 100).toFixed(1) }}%</div>
            <div style="color:white;font-weight:700px;font-size:16px">{{ $t("xiangjiaojiliangpinlv") }}</div>
          </div>
        </div>
        <div style="margin-top: 0px;">
          <p style="font-size:16px;color:#C0C4CC;text-align: center;">
            <span>{{ $t("leijibaogongshu") }}</span>
            <span style="color:white;margin-left: 8px;">{{ xiangjiaoSum }} {{ $t("jian") }}</span>
          </p>
          <p style="font-size:16px;color:#C0C4CC;text-align: center;margin-top: 8px;">
            <span>{{ $t("leijiliangpinshu") }}</span>
            <span style="color:white;margin-left: 8px;">{{ xiangjiaoGoodSum }} {{ $t("jian") }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "web_monitor_cockpit_quota",
  components: {},
  props: {
    datas: {
      type: Object,
      default: function () {
        return {};
      },
    },
    cockpitData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      xiangjiaoSum: 0,
      xiangjiaoGoodSum: 0,
      xiangjiaoSumKaijishijian: 0,
      xiangjiaoSumKaijilv: 0,
      xiangjiaoSumRunTime: 0,
      xiangjiaoSumJiadonglv: 0,
      contentHeight: 0,
    };
  },
  created() {

  },
  mounted() {
    this.utils.event_hub.$on('xiangjiaoSum', (sum, goodSum) => {
      this.xiangjiaoSum = sum
      this.xiangjiaoGoodSum = goodSum
    })
    this.utils.event_hub.$on('xiangjiaoSumKaijishijian', (sum, kjl) => {
      this.xiangjiaoSumKaijishijian = sum
      this.xiangjiaoSumKaijilv = kjl
      if (this.xiangjiaoSumRunTime > 0 && this.xiangjiaoSumKaijishijian > 0) {
        this.xiangjiaoSumJiadonglv = this.xiangjiaoSumRunTime / this.xiangjiaoSumKaijishijian * 100
      }

    })
    this.utils.event_hub.$on('xiangjiaoSumRunTime', (sum) => {
      this.xiangjiaoSumRunTime = sum
      if (this.xiangjiaoSumRunTime > 0 && this.xiangjiaoSumKaijishijian > 0) {
        this.xiangjiaoSumJiadonglv = this.xiangjiaoSumRunTime / this.xiangjiaoSumKaijishijian * 100
      }
    })
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  watch: {},
  destroyed() {
    this.utils.event_hub.$off('xiangjiaoSum')
    this.utils.event_hub.$off('xiangjiaoSumKaijishijian')
    this.utils.event_hub.$off('xiangjiaoSumRunTime')
  },
  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (this.$refs.titleBar) {
          this.contentHeight = this.$refs.container.clientHeight - this.$refs.titleBar.clientHeight;
        }
      }, 500);
    },
  },
};
</script>
